export const SHOW_TURNTABLE = 'SHOW_TURNTABLE_TDQ'
export const SET_TURNTABLE_SIZE = 'SET_TURNTABLE_SIZE_TDQ'
export const SET_RESULT_SELECTED = 'SET_RESULT_SELECTED_TDQ'
export const SET_CHOICES = 'SET_CHOICES_TDQ'
export const SET_TYPE_ACTIVE = 'SET_TYPE_ACTIVE_TDQ'
export const SET_TYPE_COUNT = 'SET_TYPE_COUNT_TDQ'
export const SET_CATEGORY = 'SET_CATEGORY_TDQ'
export const SET_LEVEL = 'SET_LEVEL_TDQ'
export const SET_HISTORY = 'SET_HISTORY_TDQ'
export const SET_MODE = 'SET_MODE_TDQ'
export const CHANGE_KEY_TEXT = 'CHANGE_KEY_TEXT_TDQ'
export const SET_TITLE_OBJ = 'SET_TITLE_OBJ_TDQ'
export const INSTANT_INIT = 'INSTANT_INIT_TDQ'
export const RESET_INITIAL_STATE = 'RESET_INITIAL_STATE_TDQ'
export const REPLACE_STATE = 'REPLACE_STATE_TDQ'
export const SET_MYSTERY_WHEEL_ON = 'SET_MYSTERY_WHEEL_ON_TDQ'
export const SET_MYSTERY_RESULT_ON = 'SET_MYSTERY_RESULT_ON_TDQ'
export const UPDATE_MYSTERY_SETTINGS = 'UPDATE_MYSTERY_SETTINGS_TDQ'
export const SET_SCORES = 'SET_SCORES_TDQ'
export const SET_AUTO_ADD_COUNT = 'SET_AUTO_ADD_COUNT_TDQ'
